import { makeRootStyles } from "../../../theme/styles";

const useStyles = makeRootStyles(
  {
    chipRoot: {
      display: "inline-block",
      width: "fit-content",
      padding: "4px 8px",
      borderRadius: "999px",
    },
    chipWrapper: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px",
    },
  },
  { name: "N0Chip" },
);

export { useStyles };
